module.exports = "/fonts/vendor/quasar-extras/roboto-web-KFOkCnqEu92Fr1MmgVxIIzQ.woff?e9dbbe8a693dd275c16d32feb101f1c1";


//////////////////
// WEBPACK FOOTER
// ./node_modules/quasar-extras/roboto-font/web-font/KFOkCnqEu92Fr1MmgVxIIzQ.woff
// module id = 6rg4
// module chunks = 49